import { createContext } from "react";

export interface AuthContextType {
  logout: () => void;
}

export const AuthContext = createContext<Partial<AuthContextType>>({});
